import { blockAnimations } from './scripts/blockAnimations'
import { stickyMenu } from './scripts/menu/stickyMenu'
import { dealersMapManager } from './scripts/dealersMap'
import { engageSliderGalleries } from './scripts/sliderGallery'
import { videoController } from './scripts/video'
import { menuControl } from './scripts/menu/menuControl'
import { globals } from '@/src/globals'
import { topBannerScoller } from './scripts/topBannerScroll'

import * as styles from './styles/index.scss'
import { tileAutoResize } from './scripts/tileAutoResize'
// import renderer from './renderer/index.pug'

// Main file
const jjm = (input: any): void => {
  const processedStyles = styles

  globals.externalInput = input

  menuControl()
  stickyMenu()
  blockAnimations()
  topBannerScoller()
  videoController()
  engageSliderGalleries()
  dealersMapManager()
  tileAutoResize()
}

export default jjm
